import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { LoadingService } from '../service/loading.service';
import { config } from '../utils/config';
import { GenericResponse } from '../interface';

@Injectable()
export class MessageInterceptor implements HttpInterceptor {
  private _messageService?: MessageService;

  private get messageService(): MessageService {
    if (!this._messageService) {
      this._messageService = this.injector.get(MessageService);
    }
    return this._messageService;
  }

  constructor(private injector: Injector, private loadingService: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Stop loader first
          this.loadingService.stopLoading();
          // Then handle the response
          this.handleResponse(event, req);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // Stop loader on error as well
        this.loadingService.stopLoading();
        // Let AuthInterceptor handle routing; just propagate
        return throwError(() => error);
      })
    );
  }

  private handleResponse(response: HttpResponse<any>, request: HttpRequest<any>): void {
    // Don't show messages for GET requests
    if (request.method === 'GET') {
      return;
    }

    const genericResponse = response.body as GenericResponse<any>;

    // Don't show messages for whitelisted codes
    if (genericResponse.code && config.messageHandling.whitelistedCodes.includes(genericResponse.code)) {
      return;
    }

    // Show message if available
    if (genericResponse.message) {
      this.messageService.add({
        severity: genericResponse.success ? 'success' : 'error',
        summary: genericResponse.success ? 'Success' : 'Error',
        detail: genericResponse.message,
        life: genericResponse.success ? 3000 : 5000
      });
    }
  }
}
